
export default class CardMember {
    
    static get selector() {
        return '.cardMember';
    }

    constructor(el) {
        this.el = el;
        this.isOpen = false;
        this.link = el.querySelector('.cardMember__showMore');
        this.setEvents();
    }

    setEvents() {
        this.el.addEventListener('mousemove', this.e_mouseMove.bind(this));
        this.link.addEventListener('click', this.e_clickToggle.bind(this));
    }

    updatePosition(x,y) {
        this.el.style.setProperty('--x', Math.round(x) +'px');
        this.el.style.setProperty('--y', Math.round(y) +'px');
    }

    toggle() {
        !this.isOpen ? this.open() : this.close();
    }
    open() {
        if(this.isOpen) return;
        this.el.classList.add('cardMember--open');
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        this.el.classList.remove('cardMember--open');
        this.isOpen = false;
    }
    
    e_mouseMove(e){
        let rect = this.el.getBoundingClientRect();
        this.updatePosition(e.clientX - rect.left,e.clientY - rect.top);
    }

    e_clickToggle(e){
        e.preventDefault();
        e.target.blur();
        this.toggle();
    }

}